export default function notificationService() {
    var service = this;
}
